import { Link } from '@/lib/router'
import type { PetDemoId } from '@/constants/petDemos'
import { petDemoImagePath } from '@/constants/petDemos'

type Props = {
  id: PetDemoId
}

export default function PetDemoImage({ id }: Props) {
  return (
    <div className="min-h-screen bg-neutral-950 text-neutral-100">
      <header className="fixed left-0 right-0 top-0 z-10 flex items-center justify-between gap-4 border-b border-white/10 bg-neutral-950/90 px-4 py-3 backdrop-blur-sm">
        <p className="text-sm font-medium tabular-nums">Demo {id}</p>
        <Link
          to="/demos/pets"
          className="text-sm text-neutral-300 underline-offset-4 hover:text-white hover:underline"
        >
          Back to gallery
        </Link>
      </header>
      <main className="pt-14 pb-8">
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img
          src={petDemoImagePath(id)}
          alt={`Pets demo ${id}`}
          className="block h-auto w-full"
          decoding="async"
        />
      </main>
    </div>
  )
}
